import React from 'react';

import { Box } from '@aircall/tractor-v2';

import { ColorChipProps } from '.';

export function ColorChip({ color, outlined, 'data-test': dataTest }: ColorChipProps) {
  return (
    <Box
      data-test={dataTest}
      borderRadius='50%'
      w={24}
      h={24}
      border='4px solid'
      borderColor={color}
      backgroundColor={outlined ? 'transparent' : color}
    />
  );
}
